/**
 * Garde « modifications non enregistrées ».
 *
 * L'éditeur de gamme porte du travail qui n'existe que dans l'écran, tant qu'on n'a pas cliqué
 * « Enregistrer » : quitter par mégarde le ferait disparaître. Deux sorties sont gardées :
 *
 * - fermer ou recharger l'onglet : l'écran demande confirmation (`beforeunload`, posé par l'éditeur) ;
 * - cliquer un lien du menu ou se déconnecter : le menu appelle `sortieAutorisee()` avant de partir.
 *
 * Le bouton « Précédent » du navigateur n'est PAS gardé : le routeur du bureau (BrowserRouter) ne
 * sait pas l'intercepter. Limite connue.
 *
 * Un simple état de module : il n'y a qu'un éditeur ouvert à la fois, et ni React ni son arbre
 * n'ont à le connaître.
 */
let nonEnregistre = false;
let messagePropre: string | null = null;

const MESSAGE_PAR_DEFAUT =
  'Vous avez des modifications non enregistrées dans le brouillon de la gamme.\n\n' +
  'Quitter maintenant les fera perdre.';

/**
 * Un écran signale qu'il porte (ou ne porte plus) du travail non enregistré. `message` dit ce qui serait perdu quand ce
 * n'est pas un brouillon de gamme (la revue d'un tarif, par exemple) ; sans travail, le message est oublié.
 */
export function signalerModifications(modifie: boolean, message?: string): void {
  nonEnregistre = modifie;
  messagePropre = modifie && message ? message : null;
}

export function aDesModificationsNonEnregistrees(): boolean {
  return nonEnregistre;
}

/**
 * Peut-on quitter l'écran ? Vrai sans modification en attente ; sinon on demande, et on respecte la
 * réponse. `confirmer` est injectable pour les tests.
 */
export function sortieAutorisee(
  confirmer: (message: string) => boolean = (m) => window.confirm(m),
): boolean {
  if (!nonEnregistre) return true;
  return confirmer(messagePropre ?? MESSAGE_PAR_DEFAUT);
}
